export default __webpack_public_path__ + "static/media/featureflow-logo-text-150x155.ed269e46.png";